import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/pages/Home';
import Login from '@/components/pages/Login';
import NotFound from '@/components/pages/NotFound';

import auth from '@/util/auth';
import store from '@/store';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: '%%ROUTER_BASE%%',
    routes: [
        {
            path: '/login/',
            name: 'Login',
            component: Login,
            beforeEnter: (to, from, next) => {
                if (auth.checkAuth()) {
                    next({
                        name: 'Home',
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: '/',
            name: 'Home',
            component: Home,
            props: { appData: this.props },
            beforeEnter: (to, from, next) => {
                const queryKeyNames = Object.keys(to.query);
                if (queryKeyNames.length) {
                    queryKeyNames.forEach((keyName) => {
                        if (Object.keys(store.state.globalFilters).includes(keyName)) {
                            store.commit('updateGlobalFilters', { name: keyName, value: to.query[keyName] });
                        } else if (Object.keys(store.state.chartFilters).includes(keyName)) {
                            store.commit('updateChartFilters', { name: keyName, value: to.query[keyName] });
                        } else if (Object.keys(store.state.chartViews).includes(keyName)) {
                            store.commit('updateChartViews', { name: keyName, value: to.query[keyName] });
                        } else if (keyName === 'currentTab') {
                            store.commit('setCurrentTab', to.query[keyName]);
                        }
                    });
                }
                if (!auth.checkAuth()) {
                    next({
                        name: 'Login',
                    });
                } else {
                    next();
                }
            },
        },
        {
            path: '*',
            name: 'NotFound',
            component: NotFound,
        },
    ],
});



// WEBPACK FOOTER //
// ./src/router/index.js